import { render } from "./ProposalView.vue?vue&type=template&id=4a4af1b6&scoped=true"
import script from "./ProposalView.vue?vue&type=script&lang=js"
export * from "./ProposalView.vue?vue&type=script&lang=js"

import "./ProposalView.vue?vue&type=style&index=0&id=4a4af1b6&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4af1b6"]])

export default __exports__